<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 内容 -->
        <el-form
            ref="form"
            slot="body"
            label-width="10em"
            size="small"
        >
            <el-card
                size="small"
                shadow="never"
                header="商品信息"
            >
                <el-form-item
                    prop="goodsName"
                    label="商品名称"
                >
                    {{ goods.goodsName }}
                </el-form-item>
                <el-form-item
                    prop="goodsShortName"
                    label="商品简称"
                >
                    {{ goods.goodsShortName }}
                </el-form-item>
                <el-form-item
                    prop="goodsSubtitle"
                    label="商品副标题"
                >
                    {{ goods.goodsSubtitle }}
                </el-form-item>
                <el-form-item
                    prop="price"
                    label="商品价格"
                >
                    {{ goods.price }}
                </el-form-item>
                <el-form-item
                    prop="marketPrice"
                    label="商品划线价"
                >
                    {{ goods.marketPrice }}
                </el-form-item>
            </el-card>
            <el-card
                size="small"
                shadow="never"
                class="ma-t"
                v-if="goods.skuList"
            >
                <el-table
                    stripe
                    border
                    size="small"
                    :data="shopGoodsAgentList"
                    style="width: 100%"
                    v-if="goods.skuList.length === 1"
                >
                    <el-table-column
                        type="expand"
                        v-if="isEdit">
                        <template slot-scope="scope">
                            <el-table
                                stripe
                                border
                                size="small"
                                :data="scope.row.storeBuyerPriceList"
                                style="width: 100%"
                            >
                                <el-table-column
                                    prop="levelName"
                                    label="门店会员等级"
                                    width="250"
                                />
                                <el-table-column
                                    prop="price"
                                    label="价格"
                                    width="200"
                                >
                                    <template slot-scope="scope1">
                                        <el-input-number
                                            size="mini"
                                            controls-position="right"
                                            :min="0.01"
                                            :precision="2"
                                            v-model.number="scope1.row.price"
                                        />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="storeName"
                        label="门店名称"
                        min-width="100"
                    />
                    <el-table-column
                        prop="agentGoodsName"
                        label="商品名称"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.agentGoodsName"
                                auto-complete="off"
                                v-if="isEdit"
                            />
                            <span v-else>{{scope.row.agentGoodsName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        label="价格"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <el-input-number
                                size="mini"
                                controls-position="right"
                                :min="0.01"
                                :precision="2"
                                v-model.number="scope.row.price"
                                v-if="isEdit"
                            />
                            <span v-else>{{scope.row.price}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="stock"
                        label="库存"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <el-input-number
                                size="mini"
                                controls-position="right"
                                :min="0"
                                :precision="0"
                                v-model.number="scope.row.stock"
                                v-if="isEdit"
                            />
                            <span v-else>{{scope.row.stock}}</span>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column
                                          prop="isAvailable"
                                          label="是否可用"
                                          width="70"
                                      >
                                          <template slot-scope="scope">
                                              <el-switch
                                                  v-model="scope.row.isAvailable"
                                              />
                                          </template>
                                      </el-table-column>-->
                </el-table>
                <el-table
                    stripe
                    border
                    size="small"
                    :data="shopGoodsAgentList"
                    style="width: 100%"
                    v-if="goods.skuList.length !== 1"
                >
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table
                                stripe
                                border
                                size="small"
                                :data="scope.row.skuList"
                                style="width: 100%"
                            >
                                <el-table-column
                                    type="expand"
                                    v-if="isEdit">
                                    <template slot-scope="scope1">
                                        <el-table
                                            stripe
                                            border
                                            size="small"
                                            :data="scope1.row.storeBuyerPriceList"
                                            style="width: 100%"
                                        >
                                            <el-table-column
                                                prop="levelName"
                                                label="门店会员等级"
                                                width="250"
                                            />
                                            <el-table-column
                                                prop="price"
                                                label="价格"
                                                width="200"
                                            >
                                                <template slot-scope="scope2">
                                                    <el-input-number
                                                        size="mini"
                                                        controls-position="right"
                                                        :min="0.01"
                                                        :precision="2"
                                                        v-model.number="scope2.row.price"
                                                    />
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="skuSn"
                                    label="sku编码"
                                    min-width="100"
                                />
                                <el-table-column
                                    prop="specDesc"
                                    label="商品规格"
                                    min-width="100"
                                />
                                <el-table-column
                                    prop="platPrice"
                                    label="平台价格"
                                    width="80"
                                />
                                <el-table-column
                                    prop="price"
                                    label="价格"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-input-number
                                            size="mini"
                                            controls-position="right"
                                            :min="0.01"
                                            :precision="2"
                                            v-model.number="scope.row.price"
                                            v-if="isEdit"
                                        />
                                        <span v-else>{{scope.row.price}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="stock"
                                    label="库存"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-input-number
                                            size="mini"
                                            controls-position="right"
                                            :min="0"
                                            :precision="0"
                                            v-model.number="scope.row.stock"
                                            v-if="isEdit"
                                        />
                                        <span v-else>{{scope.row.stock}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="storeName"
                        label="门店名称"
                        min-width="100"
                    />
                    <el-table-column
                        prop="agentGoodsName"
                        label="商品名称"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.agentGoodsName"
                                auto-complete="off"
                                v-if="isEdit"
                            />
                            <span v-else>{{scope.row.agentGoodsName}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div
                    class="ma-t"
                    v-if="isEdit">
                    <span
                        class="ma-t"
                    >
                        <span class="batch">批量设置: </span>
                        <template v-for="(item,index) in formField">
                            <el-button
                                :key="index"
                                v-if="!item.hide"
                                @click="onBatch(item)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                    </span>
                </div>
            </el-card>
            <el-card
                size="small"
                shadow="never"
                class="ma-t"
            >
                <el-button
                    size="small"
                    type="primary"
                    @click="onSave"
                    v-if="isEdit"
                >
                    保 存
                </el-button>
                <el-button
                    size="small"
                    @click="$router.back()"
                >
                    返 回
                </el-button>
            </el-card>
        </el-form>

    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';

export default {
    name: 'AddGoods',
    mixins: [pagesMixin],
    data() {
        return {
            shopGoodsAgentList: [],
            goods: {},
            isEdit: true,
        };
    },
    computed: {
        goodsId() {
            return this.$route.params.goodsId;
        },
        formField() {
            const list = [];
            list.push({ key: 'price', name: '价格', required: true });
            list.push({ key: 'agentGoodsName', name: '商品名称', required: true });
            list.push({ key: 'stock', name: '库存', required: true });
            return list;
        },
    },
    methods: {
        onSave() {
            if (this.goods.skuList.length === 1) {
                // 单规格
                this.shopGoodsAgentList.forEach(item => {
                    item.skuList[0].price = item.price;
                    item.skuList[0].stock = item.stock;
                    item.skuList[0].storeBuyerPriceList = item.storeBuyerPriceList;
                });
            }
            this.$api.Sp.ShopStoreGoods.saveShopStoreGoodsBatchAgent({
                goodsId: this.goodsId,
                agentJson: JSON.stringify(this.shopGoodsAgentList),
            }).then(json => {
                const res = json.data;
                this.$message({
                    message: res.msg,
                    type: 'success',
                });
            });
        },
        init() {
            this.$api.Sp.ShopStoreGoods.getShopStoreGoodsAgentList({
                goodsId: this.goodsId,
            }).then(json => {
                this.shopGoodsAgentList = json.data.data;
                this.shopGoodsAgentList.forEach(item => {
                    if (!item.stock && item.stock !== 0) {
                        item.stock = undefined;
                    }
                    if (!item.price) {
                        item.price = undefined;
                    }
                });
            });
            this.$api.Gd.Goods.getDetail({ id: this.goodsId }).then(json => {
                this.goods = json.data.data;
            });
        },
        onBatch(field) {
            this.$prompt(`请输入${field.name}`, '温馨提示', {
                inputValidator(val) {
                    if (!val && field.required) {
                        return `${field.name}不能为空`;
                    }
                    if (/price|stock|agentGoodsName/.test(field.key) && Number.isNaN(val)) {
                        return `请填写`;
                    }
                    return true;
                },
            }).then(({ value }) => {
                if (/price|stock|agentGoodsName/.test(field.key)) {
                    value = +value;
                }
                this.shopGoodsAgentList.forEach(item => {
                    if (field.key === 'taxRate') {
                        this.$set(item, field.key, +value);
                    } else {
                        this.$set(item, field.key, value);
                    }
                });
            });
        },
    },
    created() {
        this.init();
        if (this.$route.name === 'gd-goods-goodsStoreBatchAgentStock') {
            this.isEdit = false;
        }
    },
};
</script>

<style lang="scss">
</style>
